import React, { useEffect, useState } from "react";
import withLayout from "../layout";
import StepperForm from "../../elements/stepper-form";
import { MainContainer } from "../login/styles";
import { Button, ButtonGroup, FormContainer, FormDescription, FormGroup, FormTitle, Input, Label, StepperContainer } from "../../elements/stepper-form/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearTrackStatus, fetchTrackStatus } from "../../../store/actions/track";
import { FormPass } from "./styles";

const Home = (props) => {
  const {t} = useTranslation();

  const [formPage, setFormPage] = useState("stepper-form");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const trackStatus = useSelector((state) => state.trackStatus);

  useEffect(() => {
    document.title = `Whistleblowing Perso Base`;
  }, []);

  const formFields = [
    {
      type: "select",
      placeholder: "Enter location",
      name: "location",
      validation: "text",
      default: "",
      label: "Location",
      minimum: 1,
      maximum: 100,
      required: true,
      apiType: "API",
      selectApi: "location/select",
    },
    {
      type: "select",
      placeholder: "Enter category",
      name: "category",
      validation: "text",
      default: "",
      label: "Category (optional)",
      showItem: "locale",
      minimum: 0,
      maximum: 50,
      required: false,
      apiType: "API",
      selectApi: "whistle-category/select",
    },
    {
      type: "text",
      placeholder: "Enter title",
      name: "title",
      validation: "text",
      default: "",
      label: "Title",
      minimum: 1,
      maximum: 100,
      required: true,
    },
    {
      type: "textarea",
      placeholder: "Enter description",
      name: "description",
      validation: "text",
      default: "",
      label: "Description",
      minimum: 1,
      maximum: 1000,
      required: true,
    },
    {
      type: "text",
      placeholder: "",
      name: "pass",
      validation: "",
      default: "",
      label: "uniquePass",
      disabled: true,
      copy: "copyPassword",
    },
  ]

  const {setLoaderBox} = props;

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    if (token) {
      localStorage.setItem('accessToken', token);
    }
  }, []);

  useEffect(() => {
      if (trackStatus.data._id) {
        navigate("/track");
      }
      setLoaderBox(trackStatus.isLoading);
      if (trackStatus.error !== null) {
        props.setMessage({ type: 1, content: t(trackStatus.error), proceed: "Okay" });
        dispatch(clearTrackStatus());
      }
    }, [trackStatus, navigate, setLoaderBox, t, props, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    dispatch(fetchTrackStatus(formData.get("pass")));
  }

  return (
    <MainContainer>
      <div style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100%', minHeight:'100vh'}}>
        {formPage==="stepper-form" && <div>
          <StepperForm formFields={formFields} api={"whistleblowing"} {...props} />
          <div style={{width:'100%', display:'flex', justifyContent:'flex-end', margin:'10px 0'}}>
            <Button onClick={()=> setFormPage("pass")} >{t("trackExistingMessage")}</Button>
          </div>
        </div>}
        {
          formPage==="pass" && <FormPass>
            <StepperContainer>
              <FormContainer>
              <FormTitle>{t("titlePasswordLogin")}</FormTitle>
              <FormDescription>{t("descriptionPasswordLogin")}</FormDescription>
              <form onSubmit={handleSubmit}>
                <FormGroup style={{ position: 'relative' }}>
                    <Label htmlFor={"login"}>{t("Password")}</Label>
                    <Input
                      type={"text"}
                      id={"pass"}
                      name={"pass"}
                      placeholder={t("Enter your password")}
                      required={true}
                      className={`pass`}
                    />
                    
                  </FormGroup>
                  <ButtonGroup>
                    <Button type="submit" variant="primary">
                      {t("submit")}
                    </Button>
                  </ButtonGroup>
              </form>
              </FormContainer>
            </StepperContainer>
            <div style={{width:'100%', display:'flex', justifyContent:'flex-end', margin:'10px 0'}}>
              <Button onClick={()=> setFormPage("stepper-form")} >{t("trackExistingMessage")}</Button>
            </div>
          </FormPass>
        }
      </div>
    </MainContainer>
  );
};

export default withLayout(Home);
